import { render } from "./Shrine.vue?vue&type=template&id=90207e12"
import script from "./Shrine.vue?vue&type=script&lang=js"
export * from "./Shrine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Shrine.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90207e12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90207e12', __exports__)) {
    api.reload('90207e12', __exports__)
  }
  
  module.hot.accept("./Shrine.vue?vue&type=template&id=90207e12", () => {
    api.rerender('90207e12', render)
  })

}


export default __exports__